import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
    >
      <path
        d="M73.3872 0H62.2346L45.5059 12.5466L50.7859 16.5023C51.4219 16.3193 52.0318 16.0143 52.572 15.6135L73.3872 0Z"
        fill="#216CB7"
      />
      <g filter="url(#filter0_d_6005_2346)">
        <path
          d="M17.1924 14.1248V75.4637C17.1924 78.5394 19.693 81.04 22.7686 81.04H67.3787C70.4544 81.04 72.955 78.5394 72.955 75.4637V14.1248C72.955 11.0492 70.4544 8.54858 67.3787 8.54858H22.7686C19.693 8.54858 17.1924 11.0492 17.1924 14.1248ZM59.0144 19.7011H31.133C29.5909 19.7011 28.3449 18.4552 28.3449 16.913C28.3449 15.3708 29.5909 14.1248 31.133 14.1248H59.0144C60.5565 14.1248 61.8025 15.3708 61.8025 16.913C61.8025 18.4552 60.5565 19.7011 59.0144 19.7011Z"
          fill="url(#paint0_linear_6005_2346)"
          shape-rendering="crispEdges"
        />
        <path
          d="M17.4724 75.4637V14.1248C17.4724 11.2038 19.8476 8.82858 22.7686 8.82858H67.3787C70.2998 8.82858 72.675 11.2038 72.675 14.1248V75.4637C72.675 78.3848 70.2998 80.76 67.3787 80.76H22.7686C19.8476 80.76 17.4724 78.3848 17.4724 75.4637ZM31.133 19.9811H59.0144C60.7112 19.9811 62.0825 18.6098 62.0825 16.913C62.0825 15.2162 60.7112 13.8448 59.0144 13.8448H31.133C29.4362 13.8448 28.0649 15.2162 28.0649 16.913C28.0649 18.6098 29.4362 19.9811 31.133 19.9811Z"
          stroke="url(#paint1_linear_6005_2346)"
          strokeWidth="0.56"
          shape-rendering="crispEdges"
        />
      </g>
      <g filter="url(#filter1_d_6005_2346)">
        <path
          d="M17.1924 14.1248V75.4637C17.1924 78.5394 19.693 81.04 22.7686 81.04H67.3787C70.4544 81.04 72.955 78.5394 72.955 75.4637V14.1248C72.955 11.0492 70.4544 8.54858 67.3787 8.54858H22.7686C19.693 8.54858 17.1924 11.0492 17.1924 14.1248ZM59.0144 19.7011H31.133C29.5909 19.7011 28.3449 18.4552 28.3449 16.913C28.3449 15.3708 29.5909 14.1248 31.133 14.1248H59.0144C60.5565 14.1248 61.8025 15.3708 61.8025 16.913C61.8025 18.4552 60.5565 19.7011 59.0144 19.7011Z"
          fill="url(#paint2_linear_6005_2346)"
          shape-rendering="crispEdges"
        />
        <path
          d="M17.4724 75.4637V14.1248C17.4724 11.2038 19.8476 8.82858 22.7686 8.82858H67.3787C70.2998 8.82858 72.675 11.2038 72.675 14.1248V75.4637C72.675 78.3848 70.2998 80.76 67.3787 80.76H22.7686C19.8476 80.76 17.4724 78.3848 17.4724 75.4637ZM31.133 19.9811H59.0144C60.7112 19.9811 62.0825 18.6098 62.0825 16.913C62.0825 15.2162 60.7112 13.8448 59.0144 13.8448H31.133C29.4362 13.8448 28.0649 15.2162 28.0649 16.913C28.0649 18.6098 29.4362 19.9811 31.133 19.9811Z"
          stroke="url(#paint3_linear_6005_2346)"
          strokeWidth="0.56"
          shape-rendering="crispEdges"
        />
      </g>
      <mask
        id="mask0_6005_2346"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="17"
        y="8"
        width="57"
        height="74"
      >
        <rect
          x="17.5596"
          y="8.34692"
          width="55.7735"
          height="72.8774"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_6005_2346)">
        <path
          d="M76.8008 50.3629C76.8008 55.0561 73.3574 59.3581 67.673 62.5013C61.9972 65.6397 54.1392 67.5886 45.4458 67.5886C36.7525 67.5886 28.8945 65.6397 23.2187 62.5013C17.5342 59.3581 14.0908 55.0561 14.0908 50.3629C14.0908 45.6697 17.5342 41.3677 23.2187 38.2245C28.8945 35.0861 36.7525 33.1372 45.4458 33.1372C54.1392 33.1372 61.9972 35.0861 67.673 38.2245C73.3574 41.3677 76.8008 45.6697 76.8008 50.3629Z"
          stroke="white"
          stroke-opacity="0.2"
          strokeWidth="0.5"
        />
      </g>
      <ellipse
        cx="45.0736"
        cy="49.6193"
        rx="17.1039"
        ry="10.0392"
        fill="#216CB7"
        fill-opacity="0.3"
      />
      <g filter="url(#filter2_d_6005_2346)">
        <path
          d="M28.7023 0H17.5498L38.3737 15.6135C38.9139 16.0143 39.5151 16.3193 40.1598 16.5023C40.6564 16.6504 41.1705 16.7201 41.6933 16.7288H49.1515C49.683 16.7288 50.2058 16.6504 50.7111 16.5023L28.7023 0Z"
          fill="#BEDFFF"
        />
      </g>
      <path
        d="M36.6645 29.0072L46.6212 24.1443C46.7774 24.027 46.9667 23.9636 47.1612 23.9636C47.3557 23.9636 47.545 24.027 47.7012 24.1443C48.0601 24.3872 48.2983 24.6301 48.2983 25.1193V49.4032C48.2983 49.8856 48.2983 50.0063 48.1792 50.2491C48.0601 50.3697 47.9411 50.6126 47.822 50.6126C47.5821 50.7332 47.3423 50.7332 46.8594 50.7332H35.2322C34.7542 50.7332 34.6367 50.7332 34.3969 50.6126C34.2778 50.4904 34.038 50.3697 34.038 50.2491C33.9189 50.0096 33.9189 49.8873 33.9189 49.4049V34.0995C33.9189 32.7627 34.038 32.3993 34.1571 31.7945C34.2778 31.3104 34.516 30.8196 34.8749 30.4578C35.2322 30.0943 35.5911 29.7325 36.6661 29.0055L36.6645 29.0072ZM39.6647 34.9538C39.1884 34.9538 38.7021 35.4379 38.7021 36.1699C38.7021 36.8969 39.1818 37.3877 39.6647 37.3877H42.5459C43.0239 37.3877 43.5085 36.9019 43.5085 36.1699C43.5085 35.4446 43.0288 34.9538 42.5459 34.9538H39.6647ZM39.6647 38.5971C39.3075 38.5971 39.0693 38.8383 38.8295 39.2002C38.7099 39.5971 38.7099 40.0211 38.8295 40.418C38.891 40.5931 39.004 40.745 39.1534 40.8531C39.3027 40.9612 39.4812 41.0204 39.6647 41.0227H42.5459C43.0239 41.0227 43.5085 40.5386 43.5085 39.8065C43.5085 39.0812 43.0288 38.5888 42.5459 38.5888H39.6647L39.6647 38.5971ZM39.6647 43.4549C39.1884 43.4549 38.7021 43.9407 38.7021 44.6727C38.7021 45.4048 39.1818 45.8888 39.6647 45.8888H42.5459C43.0239 45.8888 43.5085 45.4047 43.5085 44.6727C43.5085 43.9407 43.0288 43.4566 42.5459 43.4566H39.6647L39.6647 43.4549ZM52.3736 30.4561C52.2277 30.3273 52.0522 30.2377 51.8632 30.1956C51.6742 30.1534 51.4778 30.1601 51.292 30.2149C50.933 30.3372 50.6949 30.7007 50.6949 31.1898V49.4049C50.6949 49.8873 50.6949 50.0079 50.814 50.2508C50.933 50.492 51.0521 50.492 51.1729 50.6143C51.292 50.7349 51.5301 50.7349 51.889 50.7349H54.2905C54.7702 50.7349 54.8876 50.7349 55.0084 50.6143L55.3656 50.2508C55.4847 50.1302 55.4847 49.8873 55.4847 49.4049V36.4111C55.4847 35.3156 55.4847 34.9537 55.3656 34.5886C55.2465 34.2268 55.1274 33.8633 54.8876 33.4931C54.6494 33.1312 54.5304 32.89 53.8059 32.0357L52.3736 30.4561Z"
        fill="url(#paint4_linear_6005_2346)"
        fill-opacity="0.9"
      />
      <path
        d="M31.3309 65.5943C31.6016 65.5804 31.8271 65.7158 32.0076 66.0003L34.1939 69.3839L32.9446 69.5297L31.1435 66.5938H28.801L26.2711 69.5297L24.9801 69.3839L27.9056 65.9691C28.0097 65.8372 28.1138 65.7401 28.218 65.6776C28.329 65.6151 28.4609 65.5874 28.6136 65.5943H31.3309ZM29.9046 73.361H33.3298L33.2361 74.3188H24.9385L25.0426 73.361H26.3336L26.8125 69.4776H27.8328L27.3538 73.361H28.8426L29.5089 67.9368H30.5709L30.3002 70.0919H32.8301L32.7259 71.0497H30.1857L29.9046 73.361Z"
        fill="#114E8A"
      />
      <path
        d="M44.1052 73.4338L44.0011 74.4125H35.3287L35.4328 73.4338H37.9107L38.8476 65.7192H39.9408L39.0038 73.4338H40.097L41.034 65.7192H42.1271L41.1901 73.4338H44.1052ZM36.1304 67.2393H37.1819L37.692 71.4141H36.6301L36.1304 67.2393ZM43.1891 71.4661H42.0959L43.3036 67.2393H44.3551L43.1891 71.4661Z"
        fill="#114E8A"
      />
      <path
        d="M52.3404 67.8327C52.4723 69.1098 52.7499 70.2758 53.1733 71.3308C53.5689 72.3025 54.1137 73.2395 54.8078 74.1418L53.8188 74.5062C53.3954 73.9787 53.0171 73.3367 52.6839 72.5801C52.33 71.8166 52.0489 71.0046 51.8407 70.1439C51.563 71.0185 51.2021 71.8479 50.7579 72.6322C50.3206 73.4165 49.8487 74.055 49.342 74.5478L48.3009 74.1938C49.0852 73.4928 49.7584 72.5315 50.3206 71.31C50.5636 70.7755 50.7648 70.2307 50.9245 69.6754C51.0911 69.1132 51.209 68.5788 51.2785 68.0721L51.5908 65.6776H52.6111L52.3404 67.8327ZM46.9162 65.7713L49.2171 66.6771L49.0713 67.739L46.7809 66.8332L46.9162 65.7713ZM47.8428 72.2053C47.8359 72.2261 47.8324 72.2504 47.8324 72.2782C47.8324 72.306 47.8463 72.3198 47.874 72.3198C47.9018 72.3198 47.94 72.306 47.9886 72.2782C48.3772 72.07 48.7798 71.7993 49.1962 71.4661L49.3316 72.5281C48.9082 72.8473 48.4709 73.1319 48.0198 73.3818C47.7838 73.5206 47.5686 73.59 47.3743 73.59C47.2494 73.59 47.1453 73.5588 47.062 73.4963C46.8815 73.3783 46.7913 73.1736 46.7913 72.882C46.7913 72.8265 46.7982 72.7363 46.8121 72.6114L47.2702 69.1653H45.9896L46.1042 68.1867H47.7283C47.9365 68.1867 48.0892 68.2422 48.1864 68.3532C48.2835 68.4573 48.3217 68.6066 48.3009 68.8009L47.8428 72.2053Z"
        fill="#114E8A"
      />
      <path
        d="M57.244 65.7192L59.347 66.6354L59.2013 67.6869L57.1086 66.7708L57.244 65.7192ZM60.0342 66.1044H65.2501L65.1564 67.0727H63.5531L63.2616 69.4152H64.9169L64.8024 70.373H63.1471L62.7723 73.3297H65.0419L64.9482 74.3188H58.8473L58.9514 73.3297H59.7114L60.2944 68.5615H61.2939L60.7109 73.3297H61.7312L62.512 67.0727H59.93L60.0342 66.1044ZM58.1602 72.3511V72.3719C58.1602 72.4344 58.181 72.4656 58.2226 72.4656C58.2365 72.4656 58.2643 72.4517 58.3059 72.424C58.7501 72.0561 59.1076 71.7507 59.3783 71.5078L59.4824 72.6634C59.1076 72.9757 58.7258 73.2638 58.3372 73.5275C58.115 73.6802 57.9034 73.7566 57.7021 73.7566C57.6118 73.7566 57.5181 73.7323 57.421 73.6837C57.2128 73.5657 57.1086 73.3575 57.1086 73.059C57.1086 73.0174 57.1156 72.941 57.1295 72.83L57.5876 69.1549H56.3486L56.4632 68.1971H58.0144C58.2226 68.1971 58.3823 68.2561 58.4933 68.3741C58.6044 68.492 58.646 68.6447 58.6182 68.8321L58.1602 72.3511Z"
        fill="#114E8A"
      />
      <defs>
        <filter
          id="filter0_d_6005_2346"
          x="12.1924"
          y="5.54858"
          width="65.7627"
          height="82.4915"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0783854 0 0 0 0 0.100868 0 0 0 0 0.145833 0 0 0 0.62 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6005_2346"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6005_2346"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_6005_2346"
          x="12.1924"
          y="5.54858"
          width="65.7627"
          height="82.4915"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0783854 0 0 0 0 0.100868 0 0 0 0 0.145833 0 0 0 0.62 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6005_2346"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6005_2346"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_6005_2346"
          x="15.5498"
          y="0"
          width="37.1611"
          height="20.7288"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0433333 0 0 0 0 0.133333 0 0 0 0 0.0910257 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6005_2346"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6005_2346"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_6005_2346"
          x1="45.0741"
          y1="8.34688"
          x2="45.0737"
          y2="81.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#379CFA" />
          <stop offset="1" stopColor="#81ACF8" stop-opacity="0.68" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6005_2346"
          x1="19.7901"
          y1="10.206"
          x2="70.7299"
          y2="80.1088"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#669AFF" />
          <stop offset="1" stopColor="#5BBCDB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6005_2346"
          x1="45.0741"
          y1="8.34688"
          x2="45.0737"
          y2="81.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#379CFA" />
          <stop offset="1" stopColor="#81ACF8" stop-opacity="0.68" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6005_2346"
          x1="19.7901"
          y1="10.206"
          x2="70.7299"
          y2="80.1088"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#669AFF" />
          <stop offset="1" stopColor="#5BBCDB" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_6005_2346"
          x1="36.263"
          y1="23.9636"
          x2="60.5187"
          y2="43.9334"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.369792" stopColor="#DEEBEF" />
          <stop offset="1" stopColor="#E1EFF3" stop-opacity="0.38" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Icon;
